import { render, staticRenderFns } from "./keepAdmin.vue?vue&type=template&id=27bdbb20&scoped=true&"
import script from "./keepAdmin.vue?vue&type=script&lang=js&"
export * from "./keepAdmin.vue?vue&type=script&lang=js&"
import style0 from "./keepAdmin.vue?vue&type=style&index=0&id=27bdbb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdbb20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27bdbb20')) {
      api.createRecord('27bdbb20', component.options)
    } else {
      api.reload('27bdbb20', component.options)
    }
    module.hot.accept("./keepAdmin.vue?vue&type=template&id=27bdbb20&scoped=true&", function () {
      api.rerender('27bdbb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/keepRecord/components/keepAdmin.vue"
export default component.exports